import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  isNonEmptyString,
  createCustomPropType,
  isNumeric,
} from '../../../../js/app/react/validators';
import Navigation from '../../Navigation/NavigationContainer';
import Validation from '../../Validation/ValidationContainer';
import AdvWorkflowStep from '../../AdvWorkflowStep/AdvWorkflowStepContainer';
import { BACKEND_KEY } from '../PersonalInfoWorkflowConstants';
import YesOrNoCheckbox from '../../YesOrNoCheckbox/YesOrNoCheckboxView';
import { validateDoYouHaveChildren } from '../PersonalInfoWorkflowValidator';
import workflowAnalyticsEvents from '../../AnalyticsWorkflow/AnalyticsWorkflow';
import doYouHaveChildrenShouldSkip, { localStorageKey } from './DoYouHaveChildrenShouldSkip';

class DoYouHaveChildrenView extends Component {
  componentDidUpdate({ isPopulated: previousIsPopulated }) {
    const {
      clientId, workflowId, preprocessData, children, isPopulated, store2,
    } = this.props;

    if (!previousIsPopulated && isPopulated) {
      preprocessData(clientId, children, store2(workflowId));
    }
  }

  render() {
    const {
      branch,
      workflowId,
      clientId,
      hasChildren,
      store,
      store2,
      alreadyHadChildrenData,
      hasChildrenClicked,
      isGoingForward,
      personalInfo,
      onPostProcess,
      nextIterators,
    } = this.props;

    return (
      <AdvWorkflowStep
        branch={branch}
        workflowId={workflowId}
        canSkip={doYouHaveChildrenShouldSkip(isGoingForward, alreadyHadChildrenData, clientId)}
      >
        <Validation workflowId={workflowId} validationId={`${BACKEND_KEY}.HasChildren`} />

        <h2>Do you have children?</h2>
        <YesOrNoCheckbox
          checked={hasChildren}
          onClick={hasChildrenClicked(clientId, store2(workflowId), workflowId)}
        />
        <Navigation
          nextIterators={nextIterators}
          dirtyGraphNodes={[]}
          onPostProcess={onPostProcess(hasChildren, personalInfo, store(workflowId), clientId)}
          validator={validateDoYouHaveChildren(hasChildren)}
          validationId={`${BACKEND_KEY}.HasChildren`}
          workflowId={workflowId}
          backendKey={BACKEND_KEY}
          validatedOnClick={() => {
            workflowAnalyticsEvents(workflowId, 'children_completed');
            localStorage.setItem(localStorageKey(clientId), true);
          }}
        />
      </AdvWorkflowStep>
    );
  }
}
DoYouHaveChildrenView.defaultProps = {
  hasChildren: null,
  alreadyHadChildrenData: null,
};

DoYouHaveChildrenView.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  onPostProcess: PropTypes.func.isRequired,
  store2: PropTypes.func.isRequired,
  preprocessData: PropTypes.func.isRequired,
  isPopulated: PropTypes.bool.isRequired,
  store: PropTypes.func.isRequired,
  hasChildrenClicked: PropTypes.func.isRequired,
  hasChildren: PropTypes.bool,
  alreadyHadChildrenData: PropTypes.bool,
  personalInfo: PropTypes.shape({}).isRequired,
  children: PropTypes.arrayOf(PropTypes.shape({
    FirstName: createCustomPropType(isNonEmptyString).isRequired,
    Age: createCustomPropType(isNumeric).isRequired,
  })).isRequired,
  isGoingForward: PropTypes.bool.isRequired,
  nextIterators: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired,
};

export default DoYouHaveChildrenView;
